export default "__VITE_ASSET__e1945548__"